import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ModalName } from "src/app/enums/modal-name";
import { IContact } from "src/app/models/contact/contact";
import { IFaxFolder } from "src/app/models/fax/fax-folder";
import { ISendTelnyxFaxSearchParams } from "src/app/models/telnyx/send-telnyx-fax-search-params";
import { FaxService } from "src/app/services/fax.service";
import { ModalService } from "src/app/services/modal.service";

@Component({
  selector: "app-send-fax-finish",
  templateUrl: "./send-fax-finish.component.html",
  styleUrls: ["./send-fax-finish.component.scss"],
})
export class SendFaxFinishComponent implements OnInit {
  @Output() onFormSubmit = new EventEmitter<ISendTelnyxFaxSearchParams>();
  @Output() navigateBack = new EventEmitter();

  // Leaves only notifications layout
  @Input() notificationsOnly = false;

  folders: IFaxFolder[] = [];
  foldersNames: string[] = [];
  selectedFolderName: string | null = null;
  activeContactFieldIdx = 0;

  contactTypes = ["Email", "Fax"];
  additionalRecipients = [
    {
      type: "Email",
      value: "",
    },
    {
      type: "Email",
      value: "",
    },
    {
      type: "Email",
      value: "",
    },
    {
      type: "Email",
      value: "",
    },
    {
      type: "Email",
      value: "",
    },
  ];

  constructor(
    private _faxService: FaxService,
    private _modalService: ModalService
  ) {}

  async ngOnInit() {
    this._faxService.getFolders({ pageNumber: "1", pageSize: "10" }).subscribe(folders => {
      this.folders = folders.records;
      this.foldersNames = this.getFoldersNames(this.folders);
    });
  }

  setContactType(target: any, val: string) {
    target.type = val;
  }

  openRecipientPopup(idx: number) {
    this.activeContactFieldIdx = idx;
    this._modalService.openModal(ModalName.SelectContact);
  }

  selectContact(contact: IContact) {
    this.getNumberFromContact(contact);
  }

  removeRecipient(idx: number) {
    console.log(idx);

    this.additionalRecipients.splice(idx, 1);
  }

  clearContactField(idx: number) {
    this.additionalRecipients[idx].value = "";
  }

  sendFax() {
    this.onFormSubmit.emit(this.getAdditionalInfoObject());
  }

  selectFolder(folder: string) {
    this.selectedFolderName = folder;
  }

  navigateToPreviousPage() {
    this.navigateBack.emit();
  }

  private getNumberFromContact(contact: IContact) {
    if (contact == null) {
      return;
    }

    if (this.additionalRecipients[this.activeContactFieldIdx].type === "Fax") {
      this.additionalRecipients[this.activeContactFieldIdx].value = contact.faxNumber;
    } else {
      this.additionalRecipients[this.activeContactFieldIdx].value = contact.email;
    }
  }

  private getFoldersNames(folders: IFaxFolder[]): string[] {
    return folders.map(x => x.name);
  }

  private getAdditionalInfoObject(): ISendTelnyxFaxSearchParams {
    const info: ISendTelnyxFaxSearchParams = {
      sendCopies: "false",
      generateEmailBody: "false",
      toEmail: "",
      toNumber: "",
      fromNumber: "",
      sentFrom: "",
      deliveryTo: "",
      faxSubject: "",
      notes: "",
      folderName: "",
    };

    const emails = this.getDestinations()
      .filter(recipient => recipient.type === "Email")
      .map(recipient => recipient.value.trim());

    if (emails.length > 0) {
      info.sendCopies = "true";
      info.toEmail = emails.join(",");
      info.emails = emails;
    }

    info.folderName = this.selectedFolderName ?? "";

    return info;
  }

  private getDestinations() {
    return this.additionalRecipients.filter(recipient => recipient.value !== "");
  }
}
